import { lazy } from 'react';
import { useSessionServiceContext } from '@cld/session-service';
import { FetchDeliveredAndOriginalsClient } from '@cld/media-optimizer-common';
import { RemoteModule } from '../components/remote-module/remote-module';
import { useMessage } from '../i18n/useMessage';
import { fetchDeliveredAndOriginalsClient } from '../api/fetchDeliveredAndOriginalsClient';
import { UnicornApi } from '@cld/unicorn-api';

const RemoteOptimizationReports = lazy(() =>
  import('@cld-remote/optimization_reports/index').then(({ OptimizationReports: OptimizationReportsPage }) => ({
    default: OptimizationReportsPage,
  }))
);

export const OptimizationReports = () => {
  const t = useMessage();
  const { fetchClient } = useSessionServiceContext();

  return (
    <RemoteModule documentTitle={t('optimization-reports')}>
      <RemoteOptimizationReports
        clock={() => new Date()}
        fetchDeliveredAndOriginalsClient={fetchDeliveredAndOriginalsClient(fetchClient) as FetchDeliveredAndOriginalsClient}
      />
    </RemoteModule>
  );
};
